var base = require('base/product/base');
var utils = require('../utils');
var handleReward = require('antavo_custom/handleReward');
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');
var verifyOOSIfRequired = require('antavo_custom/cart/verifyOOS').verifyOOSIfRequired;

const savelistitemcount = parseInt($('#savelistitemcount').data('itemcount'), 10);

/**
 * cart count abel
 * @param {number} cartCount - number of items in cart
 */
function orderSummeryItemLabel(cartCount) {
    if (cartCount > 1) {
        $('.order-summary-inner').removeClass('single-cart-item').addClass('multi-cart-item');
    } else {
        $('.order-summary-inner').removeClass('multi-cart-item').addClass('single-cart-item');
    }
}

/**
 * function to remove giftbox border in cart if no wishlist item
 */
function giftboxNoBorder() {
    var wishlistCount = $('.save-for-later__list .card.product-info').length;
    if (wishlistCount === 0) {
        $('.shopping-bag').addClass('noborder-giftbox');
    } else {
        $('.shopping-bag').removeClass('noborder-giftbox');
    }
}

/**
 * Remove wishlistItem and hide section if no saved item exists
 * @param {Object} productDetails productdetails object
 * @param {Object} options options object
 * @param {function} callback callback function
 */
function removeWishlistItemById(productDetails, options, callback) {
    const url = utils.appendToUrl(options.actionUrl, productDetails);
    const defaultOptions = Object.assign({
        containerClass: 'cart',
        className: 'has-saved-items',
        emptyClassName: '',
        action: 'move'
    }, options);
    const $productInfoCard = $('.uuid-' + productDetails.uuid);
    $productInfoCard.spinner().start();

    const $container = $(`.${defaultOptions.containerClass}`);
    // if exists
    $('body > .modal-backdrop').remove();
    var pageType = $('.page').data('page') || 'cart';

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            // update header description
            var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
            var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
            if (data.basketModel) {
                var noQtyError = !data.basketModel.qtyValid || (data.basketModel.qtyValid && !data.basketModel.qtyValid.error);
                $('.cartmerge-error').addClass('d-none');
                if (!data.basketModel.valid.error && noQtyError && $('.cart-error-messaging')) {
                    $('.cart-error-messaging').addClass('d-none');
                    $('.buttonErrorMessage').addClass('d-none');
                } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                    $('.cart-qty-error .cart-error_message').empty().append(data.basketModel.qtyValid.message);
                    $('.cart-qty-error').removeClass('d-none');
                    $('html, body').animate({ scrollTop: 0 }, 200);
                }
            }
            if (data.length) {
                var cartHeaderCountLabel = data.length > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
                $('.save-for-later .cart-header__description').empty().text(cartHeaderCountLabel.replace('{0}', data.length));
            }
            if (data.listIsEmpty) {
                // if no more saved items scroll to top
                $('html, body').animate({ scrollTop: 0 }, 200);


                // call during remove action to remove toast when all items are removed
                if (defaultOptions.action === 'remove') {
                    $('body').trigger('notification:close');
                }

                $container
                    .removeClass(defaultOptions.className)
                    .addClass(defaultOptions.emptyClassName);

                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
            } else {
                $container
                    .addClass(defaultOptions.className)
                    .removeClass(defaultOptions.emptyClassName);
            }

            if (typeof callback === 'function') callback(data);
            $productInfoCard.spinner().stop();
            $productInfoCard.remove();

            if (pageType === 'cart') {
                var wishlistCount = $('.save-for-later__list .card.product-info').length;
                var orderSummeryFlag = $('.estTotal-sticky-container').hasClass('estTotal-sticky');
                var shoppingBagCnt = $('.shopping-bag__list .card.product-info').length;
                var totalItems = $('.cart-header__description').data('tealiumitemquantity');

                if (shoppingBagCnt > 0 && (shoppingBagCnt + wishlistCount) >= 2 && !orderSummeryFlag) {
                    $('.estTotal-sticky-container').addClass('estTotal-sticky');
                } else if (shoppingBagCnt === 1 && wishlistCount === 0 && orderSummeryFlag) {
                    $('.estTotal-sticky-container').removeClass('estTotal-sticky');
                }
                let cartcountRound = parseInt(totalItems, 10).toFixed();
                let cartItemCount = cartcountRound > 1 ? '(' + cartcountRound + ' items)' : '(' + cartcountRound + ' item)';
                $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
                orderSummeryItemLabel(parseInt(totalItems, 10).toFixed());
                giftboxNoBorder();
            }
        },
        error: function (err) {
            utils.showErrorToast(err.message);
            $productInfoCard.spinner().stop();
        }
    });
}

/**
 * Display all save for later items
 */
function viewAllsaveForLaterItems() {
    var pageType = $('.page').data('page') || 'cart';
    var viewAllSfl = window.sessionStorage.getItem('viewAllSfl');
    if (utils.getCurrentBreakpoint() === 'mobile' && pageType === 'cart' && viewAllSfl == null) {
        var listItems = $('.save-for-later-mobile-only .save-for-later__list .product-info');
        listItems.show();
        var viewAllItemcta = $('#showallsaveditembtn');
        viewAllItemcta.hide();
        if (listItems.length > savelistitemcount) {
            listItems.hide();
            // Show only configured number of items
            listItems.slice(0, savelistitemcount).show();
            viewAllItemcta.show();
        }
        if (viewAllItemcta.is(':visible')) {
            listItems.eq(savelistitemcount - 1).addClass('item-no-border');
        }
    }
}

/**
 * load withlist based on current page information
 */
// eslint-disable-next-line
function loadWishlist(actionUrl, params) {

    var options = {
        containerClass: 'js-product--saveforlater',
        actionUrl: actionUrl,
        action: 'loadmore'
    };

    const url = utils.appendToUrl(options.actionUrl, params);

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $(`.${options.containerClass}`).html(response);
            viewAllsaveForLaterItems();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * load product list based on provided url into target container
 * @param {string} listUrl product listing url
 * @param {jQuery} $targetElem jQuery element to inject list
 * @param {string} pid product Id
 * @param {function} callback callback function
 */
function loadUpdatedProductListByUrl(listUrl, $targetElem, pid, callback) {
    $.ajax({
        url: listUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            $.spinner().stop();
            $targetElem.html(data.renderTemplate);
            viewAllsaveForLaterItems();

            if (data.items.length) {
                const $cartPage = $('.cart');

                if (data.action.indexOf('Wishlist') !== -1) {
                    $cartPage.addClass('has-saved-items');
                    tealiumEnable.getAnalyticsData('saveForLaterEvent', pid);
                    tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                }
                if (data.action.indexOf('Cart') !== -1) {
                    if (!$('.loyalty-info-message .tooltip-wrapper').length) {
                        if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                            var html = '<input type="hidden" class="loyalty-info-message-points" value="' + data.antavoRewardPoints.points + '" />';
                            $('.loyalty-info-message .tooltip-wrapper').empty().append(html);
                            $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                            $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                            if (data.antavoRewardPoints.points === 0) {
                                $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                            }
                        }
                    }
                    $cartPage.addClass('has-cart-items');
                    $('.shipping--intro').removeClass('d-none');
                    $cartPage.removeClass('cart-empty');
                    var event = 'cart_add';
                    tealiumEnable.getAnalyticsData('moveToBagEvent', pid, data, event);
                    tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                }
            }

            if (typeof callback === 'function') {
                callback(data);
            }
        },
        error: function (err) {
            utils.showErrorToast(err.message);
            $.spinner().stop();
        }
    });
}

/**
 * Get wishlist data from markup
 * @returns {Object} wishlist data objectType
 */
function getWishlistData() {
    var $loadMore = $('.show-more');
    var pageNumber = $loadMore.data('page-number') || 1;
    var pageType = $('.page').data('page') || 'cart';
    var pageSize = $loadMore.data('page-size') || 4;
    var actionUrl = $loadMore.data('action');

    // since page mapping for account is set as accSummary, mapping is required.
    var pageTypeMapping = {
        account: 'accSummary'
    };

    return {
        pageNumber,
        pageType: pageTypeMapping[pageType] || pageType,
        pageSize,
        actionUrl
    };
}

/**
 * Show exclusive error toast
 * @param {Object} message - error message
 * @param {boolean} sticky - flag to indicate sticky or non sticky toast
 */
function exclusiveErrorToast(message, sticky = false) {
    $('body').trigger('notification:close');
    if (!message) return;
    var splitMsg = message.split('{0}');
    if (!splitMsg && splitMsg.length < 2) return;
    var message1 = splitMsg[0];
    var message2 = splitMsg[1];
    const $targetElm = $('.ds-globalnav-header');
    const classNames = sticky ? 'is-sticky' : '';
    const toastMarkup = `<div class="ds-toast ds-toast--error ${classNames} open exclusive-error">
                            <span class="ds-toast__icon">
                                <svg class="icon-error">
                                    <use xlink:href="#alert-notifcation"></use>
                                </svg>
                            </span>
                            <div class="toast-message-wrapper">
                                <span class="ds-toast__message cart-member-global-msg1">${message1}</span>
                                <span class="member-sign-in-link signin-link cart-member-global-msg">sign in </span> 
                                <span class="move-to-bag">${message2}</span>
                                </span>
                            </div>
                        </div>`;
    $targetElm.remove('.ds-toast');
    $targetElm.append(toastMarkup);
    var $newToast = $targetElm.find('.ds-tosast');
    $newToast.trigger('focus');
}

/**
 * Render wishlist page errors inline and scroll them into view.
 * Falls back to the global header toast when no inline container exists.
 * @param {string} message - error message
 */
function showWishlistPageError(message) {
    if (!message) return;

    const $inlineErrorTarget = $('.wishlist-error-msg-wrapper, .carterr-msg-wrapper').find('.listitem-exist-messaging').first();

    if (!$inlineErrorTarget.length) {
        utils.showErrorToast(message);
        const $headerToast = $('.ds-globalnav-header').find('.ds-toast');
        $headerToast.find('.ds-toast__dismiss').remove();
        return;
    }

    utils.showErrorToast(message, $inlineErrorTarget);
    $inlineErrorTarget.removeClass('d-none');

    const $toast = $inlineErrorTarget.find('.ds-toast');
    $toast.find('.ds-toast__dismiss').remove();

    const toastOffset = $toast.offset();
    if ($toast.length && toastOffset) {
        const anchorPosition = toastOffset.top - ($('.js-globalnav-header').outerHeight() || 0);
        $('html, body').animate({ scrollTop: anchorPosition }, 100);
    }
}

/**
 * Function to initialize payment methods
 * @param {Object} totals - order totals
 *
 */
function initializePaymentMethods(totals) {
    if ($('#checkout-main').length && ($('#checkout-main').attr('data-checkout-stage') === 'payment')) {
        var summaryHelpers = require('base_global/checkout/summary');
        var adyenCheckout = require('adyen_custom/adyen/checkout');
        summaryHelpers.updateTotals(totals);
        adyenCheckout.init();
    }
}

/**
 * Updates global nav cart count from wishlist ATC response.
 * Shared wishlist pages can miss minicart listeners, so refresh directly.
 * @param {Object} data - add to cart response object
 */
function updateGlobalNavCartCount(data) {
    var rawCount = data && data.quantityTotal;

    if (typeof rawCount === 'undefined' && data && data.cart) {
        rawCount = data.cart.numItems;
    }

    var parsedCount = parseInt(rawCount, 10);
    if (!Number.isNaN(parsedCount)) {
        utils.updateCartCount(parsedCount);
    }
}

module.exports = {
    moveToWishlist: function () {
        $('body').on('click', '.product-move .move-to-saved-item', function (e) {
            e.preventDefault();
            var $productInfoCard = $(this).closest('.product-info');
            var url = $(this).attr('href');
            var pid = $(this).data('pid');
            var uuid = $(this).data('uuid');
            var pageType = $('.page').data('page') || 'cart';
            var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
            var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
            $('.cartmerge-error').addClass('d-none');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            const productDetails = {
                pid,
                uuid
            };
            var csrf_token = $('.csrf-token').attr('data-csrf-value');

            $productInfoCard.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal,
                    csrf_token: csrf_token,
                    pageType: pageType
                },
                success: function (data) {
                    // if error then show error message
                    if (data.error) {
                        if (data.addToCartError) {
                            // eslint-disable-next-line no-param-reassign
                            data.basketModel.action = 'Cart';
                            var cartCustomService = require('base_global/cart/cartCustomService');
                            if ($('.js-product--list').length) {
                                if (data.basketModel.items.length) {
                                    $('.js-product--list').html(data.basketModel.renderTemplate);
                                } else {
                                    const $targetContainer = $('.emptycart-ooslist');
                                    $targetContainer.html(data.basketModel.renderTemplate);
                                    const $cartPage = $('.cart');
                                    $cartPage.removeClass('has-cart-items, cart-page');
                                    $('.shipping--intro').addClass('d-none');
                                    $cartPage.addClass('cart-empty');
                                }
                                cartCustomService.updateCartComponents(data.basketModel);
                            }
                            cartCustomService.updateCartTotals(data.basketModel);
                            cartCustomService.updateApproachingDiscounts(data.basketModel.approachingDiscounts);
                            cartCustomService.validateBasket(data.basketModel);
                            initializePaymentMethods(data.basketModel.totals);
                            // Antavo Loyalty start
                            if (data.basketModel.antavoRewardPoints && data.basketModel.antavoRewardPoints.points >= 0) {
                                $('.tooltip-wrapper .tooltip-points').empty().append('Members earn points ' + data.basketModel.antavoRewardPoints.points + ' Preferred Loyalty points on this purchase.');
                                $('.loyalty-info-message-points').val(data.basketModel.antavoRewardPoints.points);
                                $('.reward-earned-payment').html(data.basketModel.antavoRewardPoints.points);
                                $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.basketModel.antavoRewardPoints.points);
                                $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                                if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                    $('.loyalty-info-message .checkout-loyaltyrewards-container').removeClass('hide-antavo-copy');
                                }
                                if (data.basketModel.antavoRewardPoints.points === 0) {
                                    $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                                    if ($('.loyalty-info-message .checkout-loyaltyrewards-container').length) {
                                        $('.loyalty-info-message .checkout-loyaltyrewards-container').addClass('hide-antavo-copy');
                                    }
                                }
                            }
                        }
                        $productInfoCard.spinner().stop();
                        showWishlistPageError(data.msg);

                        return;
                    }

                    const $saveForLaterListUrl = $('.save-for-later-url');
                    const $targetContainer = $('.save-for-later__list');

                    // TODO not sure if we need this
                    base.miniCartReportingUrl(data.reportingURL, data.error);

                    // call logic in cart js to load the updated cart list
                    $('body').trigger('product:savedForLater', productDetails);
                    utils.showConfirmToast(data.msg);

                    // load savedItems updated list
                    loadUpdatedProductListByUrl($saveForLaterListUrl.val(), $targetContainer, pid, () => {
                        $('body').trigger('product:afterSavedForLater', productDetails);
                        $productInfoCard.spinner().stop();
                        if (pageType === 'cart') {
                            var wishlistCount = $('.save-for-later__list .card.product-info').length;
                            var orderSummeryFlag = $('.estTotal-sticky-container').hasClass('estTotal-sticky');
                            var shoppingBagCnt = $('.shopping-bag__list .card.product-info').length;

                            if (shoppingBagCnt > 0 && (shoppingBagCnt + wishlistCount) >= 2 && !orderSummeryFlag) {
                                $('.estTotal-sticky-container').addClass('estTotal-sticky');
                            } else if (shoppingBagCnt === 1 && wishlistCount === 0 && orderSummeryFlag) {
                                $('.estTotal-sticky-container').removeClass('estTotal-sticky');
                            }
                            giftboxNoBorder();
                        }
                    });
                    handleReward.rewardsResponse(data);
                    if (pageType === 'cart' && $('.rewardlimitmessagewrapper').length) {
                        $('.rewardlimitmessagewrapper').addClass('hide');
                    }
                    if (pageType === 'cart' && $('.rewards-redeem-error').length) {
                        $('.rewards-redeem-error').remove();
                    }
                },
                error: function (err) {
                    let message = err.responseJSON.message;
                    let errorHandling = function () {
                        $productInfoCard.spinner().stop();
                        if (!err.responseJSON.csrfError && (err.responseJSON && err.responseJSON.redirectUrl)) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                        showWishlistPageError(message);
                    };
                    if (err.responseJSON.csrfError) {
                        utils.handleCsrfToken(errorHandling);
                    } else {
                        errorHandling();
                    }
                }
            });
        });
    },
    addToCartFromWishlist: function () {
        $('body').on('click', '.product-move .add-to-cart', function (event) {
            event.preventDefault();

            $('body').trigger('product:beforeAddToCart', this);
            var $productInfoCard = $(this).closest('.product-info');
            var pageType = $('.page').data('page') || 'cart';
            var pid = $(this).data('pid');
            var uuid = $(this).data('uuid');
            var addToCartUrl = $(this).data('url');
            var actionUrl = $(this).data('action');
            var options = {};
            var $spinnerContainer = $('.save-for-later__list');
            var moveToBagBtn = $(this);
            moveToBagBtn.addClass('click-disabled');

            // TODO find a better way to differentiate page
            if (pageType !== 'cart') {
                options = {
                    containerClass: 'saved-items',
                    emptyClassName: 'is-empty'
                };
            }
            var csrf_token = $('.csrf-token').attr('data-csrf-value');

            var productDetails = {
                pid: pid,
                uuid: uuid,
                quantity: 1,
                pageType: pageType,
                csrf_token: csrf_token
            };

            if ($(this).data('option')) {
                productDetails.options = JSON.stringify($(this).data('option'));
            }
            $spinnerContainer.spinner().start();

            $(this).trigger('updateAddToCartFormData', productDetails);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: productDetails,
                    success: function (data) {
                        if (data.error) {
                            moveToBagBtn.removeClass('click-disabled');
                            $spinnerContainer.spinner().stop();
                            showWishlistPageError(data.message);
                            return;
                        }
                        updateGlobalNavCartCount(data);
                        verifyOOSIfRequired(data, function (updatedData) {
                            data = updatedData; // eslint-disable-line
                            const $cartListUrl = $('.cart-list-url');
                            const $targetContainer = $('.shopping-bag__list');
                            utils.showConfirmToast(data.message);

                            // TODO not sure if we need this
                            base.miniCartReportingUrl(data.reportingURL, data.error);

                            options.actionUrl = actionUrl;


                            // do not load product load if this is not in cart page
                            if ($cartListUrl.length) {
                                $('html, body').animate({ scrollTop: 0 }, 200);
                                // update shopping bag item from cart
                                $productInfoCard.spinner().stop();
                                $productInfoCard.remove();
                                loadUpdatedProductListByUrl($cartListUrl.val(), $targetContainer, pid, () => {
                                    // remove wishlist item and update cart list
                                    removeWishlistItemById(productDetails, options);
                                    $('body').trigger('product:afterAddToCart', data);

                                    if (pageType === 'cart') {
                                        var wishlistCount = $('.save-for-later__list .card.product-info').length;
                                        var orderSummeryFlag = $('.estTotal-sticky-container').hasClass('estTotal-sticky');
                                        const $mainRecs = $('.cart-main-recommendations');
                                        const $emptyRecs = $('.cart-empty-recommendations');
                                        var $summaryMsg = $('.signin-pts');
                                        if (data.cart.items.length > 0 && (data.cart.items.length + wishlistCount) >= 2 && !orderSummeryFlag) {
                                            $('.estTotal-sticky-container').addClass('estTotal-sticky');
                                        } else if (data.cart.items.length === 1 && wishlistCount === 0 && orderSummeryFlag) {
                                            $('.estTotal-sticky-container').removeClass('estTotal-sticky');
                                        }
                                        giftboxNoBorder();
                                        if (data.cart.items.length > 0) {
                                            $mainRecs.removeClass('d-none');
                                            $emptyRecs.addClass('d-none');
                                            $summaryMsg.removeClass('no-items');
                                            $('.page.cart').removeClass('empty-cart-antavopoints');
                                        } else {
                                            $mainRecs.addClass('d-none');
                                            $emptyRecs.removeClass('d-none');
                                        }
                                    }
                                });
                                handleReward.rewardsResponse(data);
                                setTimeout(() => {
                                    $spinnerContainer.spinner().stop();
                                }, 100);
                            } else {
                                // remove wishlist item and update cart list
                                var eventName = 'cart_add,cart_open';
                                tealiumEnable.getAnalyticsData('moveToBagEvent', pid, data.cart, eventName);
                                tealiumEnable.getAnalyticsData('cartAutoUpdateProductEvent', data);
                                removeWishlistItemById(productDetails, options, () => {
                                    var wishlistData = getWishlistData();
                                    loadWishlist(wishlistData.actionUrl, {
                                        pageNumber: Number(wishlistData.pageNumber),
                                        pageType: wishlistData.pageType,
                                        pageSize: wishlistData.pageSize
                                    });
                                });
                                utils.showConfirmToast(data.message);
                                $('.minicart').trigger('count:update', data);
                                $('body').trigger('product:afterAddToCart', data);
                                setTimeout(() => {
                                    $spinnerContainer.spinner().stop();
                                }, 100);
                            }
                            var noQtyError = !data.cart.qtyValid || (data.cart.qtyValid && !data.cart.qtyValid.error);
                            $('.cartmerge-error').addClass('d-none');
                            if (pageType === 'cart' && $('div.ds-cart-error-messaging').length && !data.cart.valid.error && noQtyError) {
                                $('.cart-error-messaging').addClass('d-none');
                                $('.buttonErrorMessage').addClass('d-none');
                            } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
                                $('.cart-qty-error .cart-error_message').empty().append(data.cart.qtyValid.message);
                                $('.cart-qty-error').removeClass('d-none');
                                $('html, body').animate({ scrollTop: 0 }, 200);
                            }

                            if (pageType === 'cart' && $('.rewardlimitmessagewrapper').length) {
                                $('.rewardlimitmessagewrapper').addClass('hide');
                            }
                            if (pageType === 'cart' && $('.rewards-redeem-error').length) {
                                $('.rewards-redeem-error').remove();
                            }
                        });
                    },
                    error: function (err) {
                        let message = err.responseJSON.message;
                        let errorHandling = function () {
                            moveToBagBtn.removeClass('click-disabled');
                            if (err.responseJSON && err.responseJSON.errorCode && err.responseJSON.errorCode.length > 0 && err.responseJSON.errorCode[0] === 'error.members.only') {
                                exclusiveErrorToast(message);
                            } else {
                                showWishlistPageError(message);
                            }
                            $spinnerContainer.spinner().stop();
                            tealiumEnable.getAnalyticsData('serverError', err.responseJSON.errorCode);
                        };
                        if (err.responseJSON.csrfError) {
                            utils.handleCsrfToken(errorHandling);
                        } else {
                            errorHandling();
                        }
                    }
                });
            }
        });
    },

    removeWishlist: function () {
        $('body').on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            var productID = $(this).data('pid');
            var actionUrl = $(this).data('action');
            var uuid = $(this).data('uuid');
            var pageType = $('.page').data('page') || 'cart';
            var toastMessage = $(this).data('toastmsg');
            var options = {};

            var productDetails = {
                pid: productID,
                uuid: uuid
            };

            if (pageType !== 'cart') {
                options = {
                    containerClass: 'saved-items',
                    emptyClassName: 'is-empty'
                };
            }

            options.actionUrl = actionUrl;
            options.action = 'remove';

            removeWishlistItemById(productDetails, options, () => {
                utils.showConfirmToast(toastMessage);
                var wishlistData = getWishlistData();
                loadWishlist(wishlistData.actionUrl, {
                    pageNumber: Number(wishlistData.pageNumber),
                    pageType: wishlistData.pageType,
                    pageSize: wishlistData.pageSize
                });
            });
            if (pageType === 'cart' && $('.rewardlimitmessagewrapper').length) {
                $('.rewardlimitmessagewrapper').addClass('hide');
            }
            if (pageType === 'cart' && $('.rewards-redeem-error').length) {
                $('.rewards-redeem-error').remove();
            }
        });
    },

    lazyLoadWishlist: function () {
        var pageType = $('.page').data('page') || 'cart';
        // Load next page when its around last 2 items
        const options = {
            root: null,
            rootMargin: '0px 0px 500px 0px',
            threshold: 0
        };

        const lazyLoad = function () {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio) {
                        var $loadMore = $('.show-more:not(.no-lazy-load)');
                        var hasShowMore = $loadMore.data('show-more');

                        // if no load-more available, no more pages to load
                        if (hasShowMore) {
                            let pageNumber = $loadMore.data('page-number') || 0;
                            var actionUrl = $loadMore.data('action');
                            var uuid = $loadMore.data('uuid');
                            var publicView = $loadMore.data('public-view');
                            loadWishlist(actionUrl, {
                                pageNumber: Number(pageNumber) + 1,
                                pageType: pageType,
                                id: uuid,
                                publicView: publicView
                            });
                        }
                    }
                });
            }, options);

            const targets = document.querySelectorAll('.end-of-list');
            targets.forEach((target) => {
                observer.observe(target);
            });
        };

        $('body').on('product:afterSavedForLater', lazyLoad);
        lazyLoad();
    },
    reloadWishlist: function () {
        // eslint-disable-next-line
        $('body').on('wishlist:update', function (event, data) {

            if (data.listIsEmpty) {
                return true;
            }

            var wishlistData = getWishlistData();
            loadWishlist(wishlistData.actionUrl, {
                pageNumber: Number(wishlistData.pageNumber),
                pageType: wishlistData.pageType,
                pageSize: wishlistData.pageSize
            });
        });
    },

    copyProductLink: function () {
        $('body').on('click', '.share-list', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            try {
                document.execCommand('copy');
                $temp.remove();
                utils.showConfirmToast($('#copySuccessMsg').val());
            } catch (err) {
                utils.showErrorToast(err.message);
            }
        });
    },

    viewAllSavedItems: function () {
        $('#showallsaveditembtn').on('click', function () {
            const hiddenItems = $('.save-for-later__list .product-info:hidden');
            hiddenItems.show();
            $('.save-for-later__list .product-info').removeClass('item-no-border');
            window.sessionStorage.setItem('viewAllSfl', true);
            // hide the button after click event
            $(this).hide();
        });
    },

    viewAllsaveForLaterItems: viewAllsaveForLaterItems
};
